/* Six o - cart gift (1 free pair of socks) — v5.2 2026-10-10.
   - Gift only for carts of EUR 150+ (paid amount after line discounts).
   - Below threshold: progress message shows how much is left; gift removed.
   - Social proof around the checkout button: stars above, trust line below, IG line last.
   - Kaching cart bar untouched.
   Hard stops kept: paid gift line -> removed; manual removal respected; max 3 adds. */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 58434858320204;
  var THRESHOLD = 15000; // cents
  var OFFER_ID = 'sixo-gift-offer';
  var SP_TOP_ID = 'sixo-sp-top';
  var SP_BOT_ID = 'sixo-sp-bottom';
  var DECLINE_KEY = 'sixo_gift_declined';
  var MAX_ADDS = 3;

  var busy = false, adds = 0, weChanged = false, prevHadGift = null, lastCart = null;

  function declined() { try { return !!sessionStorage.getItem(DECLINE_KEY); } catch (e) { return false; } }
  function decline(r) { try { sessionStorage.setItem(DECLINE_KEY, r); } catch (e) {} }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i];
    return null;
  }
  function realSubtotal(cart) {
    var s = 0;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id !== GIFT_VARIANT_ID) s += cart.items[i].final_line_price;
    return s;
  }
  function hasRealItems(cart) { return cart.items.some(function (i) { return i.variant_id !== GIFT_VARIANT_ID; }); }
  function money(cents) {
    var cur = (lastCart && lastCart.currency) || 'EUR';
    var sym = cur === 'EUR' ? '€' : (cur === 'USD' ? '$' : cur + ' ');
    return sym + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function changeQty(qty) {
    weChanged = true;
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: String(GIFT_VARIANT_ID), quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function addGift() {
    weChanged = true; adds++;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }) }).then(function (r) { return r.json(); }).then(getCart);
  }

  /* ---------- offer / progress box ---------- */

  function offerHTML(state, missingCents, progress) {
    var added = state === 'added', below = state === 'below', body;
    if (below) {
      body = '<p style="margin:0;font-weight:600;font-size:14px;line-height:1.4">&#127873; FREE socks on orders over €150 <span style="font-weight:500;opacity:.75">&mdash; add ' + money(missingCents) + ' more</span></p>' +
        '<div style="margin-top:8px;height:6px;border-radius:3px;background:#ece5d2;overflow:hidden"><div style="height:100%;width:' + Math.round(progress * 100) + '%;background:#cdbf88;border-radius:3px"></div></div>';
    } else {
      body = '<p style="margin:0;font-weight:600;font-size:14px;line-height:1.4">&#127873; Your order qualifies &mdash; 1 pair of socks for FREE</p>' +
        (added ? '<p style="margin:4px 0 0;font-size:12.5px;line-height:1.4;color:#5c5648">&#10003; Added to your cart &mdash; no code needed</p>' : '');
    }
    return '<div id="' + OFFER_ID + '" data-state="' + state + '" style="margin:10px 0;padding:12px 14px;border-radius:12px;border:1px solid ' + (added ? '#cdbf88' : '#e6dfce') + ';background:' + (added ? '#fff8dd' : '#faf6ec') + ';font-family:inherit;color:#171717;text-align:left">' +
      '<p style="margin:0 0 3px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#9a8850;font-weight:600">Free gift</p>' + body + '</div>';
  }

  function ensure(anchor, position, html, state, id) {
    if (!anchor) return;
    var current = position === 'afterend' ? anchor.nextElementSibling : anchor.firstElementChild;
    if (current && current.id === id) {
      if (current.getAttribute('data-state') !== state || state === 'below') current.outerHTML = html;
      return;
    }
    anchor.insertAdjacentHTML(position, html);
  }

  function renderOffer(cart) {
    if (!cart) return;
    if (!hasRealItems(cart)) {
      document.querySelectorAll('#' + OFFER_ID).forEach(function (n) { n.remove(); });
      return;
    }
    var sub = realSubtotal(cart), state, missing = 0, progress = 1;
    if (sub < THRESHOLD) { state = 'below'; missing = THRESHOLD - sub; progress = sub / THRESHOLD; }
    else state = giftLine(cart) ? 'added' : 'offer';
    var html = offerHTML(state, missing, progress);

    var promo = document.querySelector('.kaching-cart__tiered-promotions-bar');
    if (promo) ensure(promo, 'afterend', html, state, OFFER_ID);
    else ensure(document.querySelector('.kaching-cart__contents'), 'afterbegin', html, state, OFFER_ID);
    ensure(document.querySelector('.cart-drawer__inner, .drawer--cart .drawer__inner'), 'afterbegin', html, state, OFFER_ID);
    ensure(document.querySelector('.cart-form, form[action="/cart"], form[action^="/cart?"]'), 'afterbegin', html, state, OFFER_ID);
    dedupe(OFFER_ID);
  }

  function dedupe(id) {
    var parents = [];
    document.querySelectorAll('#' + id).forEach(function (n) {
      if (parents.indexOf(n.parentElement) === -1) parents.push(n.parentElement);
      else n.remove();
    });
  }

  /* ---------- social proof around the checkout button ---------- */

  function spTopHTML() {
    return '<div id="' + SP_TOP_ID + '" data-state="1" style="margin:6px 0 8px;text-align:center;font-family:inherit">' +
      '<span style="color:#c9a94e;font-size:14px;letter-spacing:2px">&#9733;&#9733;&#9733;&#9733;&#9733;</span> ' +
      '<span style="font-size:12.5px;color:#171717;font-weight:600">4.8/5</span> ' +
      '<span style="font-size:12.5px;color:#5c5648">&mdash; loved by 4,000+ players</span></div>';
  }
  function spBottomHTML() {
    return '<div id="' + SP_BOT_ID + '" data-state="1" style="margin:8px 0 2px;text-align:center;font-family:inherit">' +
      '<p style="margin:0;font-size:11.5px;color:#5c5648;line-height:1.5">&#128274; Secure checkout &nbsp;·&nbsp; 14-day returns &nbsp;·&nbsp; Shipped to 40+ countries</p>' +
      '<p style="margin:3px 0 0;font-size:11.5px;color:#9a8850"><a href="https://www.instagram.com/6o.apparel/" target="_blank" rel="noopener" style="color:#9a8850;text-decoration:none">Join 21k+ players &#64;6o.apparel</a></p></div>';
  }

  function checkoutButtons() {
    var sels = ['button[name="checkout"]', 'input[name="checkout"]', 'a[href="/checkout"]', '.kaching-cart__checkout-button', '.kaching-cart__footer button'];
    var found = [];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (b) { if (found.indexOf(b) === -1) found.push(b); });
    });
    return found;
  }

  function renderSocialProof(cart) {
    if (!cart || !hasRealItems(cart)) {
      document.querySelectorAll('#' + SP_TOP_ID + ',#' + SP_BOT_ID).forEach(function (n) { n.remove(); });
      return;
    }
    checkoutButtons().forEach(function (btn) {
      if (!btn.parentElement) return;
      var prev = btn.previousElementSibling;
      if (!prev || prev.id !== SP_TOP_ID) btn.insertAdjacentHTML('beforebegin', spTopHTML());
      var next = btn.nextElementSibling;
      if (!next || next.id !== SP_BOT_ID) btn.insertAdjacentHTML('afterend', spBottomHTML());
    });
    dedupe(SP_TOP_ID);
    dedupe(SP_BOT_ID);
  }

  /* ---------- keep the gift line correct ---------- */

  function reconcile(cart, changedByUs) {
    var gift = giftLine(cart), real = hasRealItems(cart);
    var eligible = real && realSubtotal(cart) >= THRESHOLD;

    if (gift) {
      if (!real || !eligible) { busy = true; return changeQty(0).then(function (c) { busy = false; return c; }); }
      if (gift.final_line_price > 0) { decline('price'); busy = true; return changeQty(0).then(function (c) { busy = false; return c; }); }
      if (gift.quantity > 1) { busy = true; return changeQty(1).then(function (c) { busy = false; return c; }); }
      return Promise.resolve(cart);
    }
    if (prevHadGift === true && eligible && !changedByUs) { decline('manual'); return Promise.resolve(cart); }
    if (eligible && !declined() && adds < MAX_ADDS) {
      busy = true;
      return addGift().then(function (c) { busy = false; return c; }).catch(function () { busy = false; return cart; });
    }
    return Promise.resolve(cart);
  }

  /* ---------- loop ---------- */

  function tick() {
    if (busy) return;
    getCart().then(function (cart) {
      var changedByUs = weChanged;
      weChanged = false;
      return reconcile(cart, changedByUs).then(function (after) {
        var c = (after && after.items) ? after : cart;
        lastCart = c;
        prevHadGift = !!giftLine(c);
        renderOffer(c);
        renderSocialProof(c);
      });
    }).catch(function () {});
  }

  function boot() {
    tick();
    setInterval(tick, 2500);
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        renderOffer(lastCart);
        renderSocialProof(lastCart);
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
